import { keepPreviousData, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { TeamRole } from '@/common/api/types/teamRoles';
import { sortNamesAlphabetically } from '@/common/utils/sorting';
import { capacityQueryKeys } from '@/features/settings/capacity/queryKeys';
import { TeamRolesApi } from '@/features/settings/team-roles/api';

export const getTeamRolesQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.teamRoles.all(),
    queryFn: async () => {
      return await TeamRolesApi.getTeamRoles();
    },
    select: sortNamesAlphabetically,
  };
};

export const getSearchTeamRolesQueryOptions = (query: string = '') => {
  return {
    queryKey: capacityQueryKeys.teamRoles.search(query),
    queryFn: () => TeamRolesApi.searchTeamRoles(query),
    placeholderData: keepPreviousData,
    select: sortNamesAlphabetically,
  };
};

export const useTeamRolesQuery = (options: Partial<UseQueryOptions<TeamRole[]>> = {}) => {
  return useQuery({ ...getTeamRolesQueryOptions(), ...options });
};

export const useSearchTeamRolesQuery = (query: string = '') => {
  return useQuery<TeamRole[], Error, TeamRole[]>({ ...getSearchTeamRolesQueryOptions(query) });
};
